export default "__VITE_ASSET__58fb6755__"